import React from 'react';
import BookMockup from './BookMockup';
import CtaButton from './CtaButton';

// Finaler Call-to-Action
function FinalCta() {
  return (
    <section className="bg-[#1E3A8A] py-16 text-white">
      <div className="mx-auto grid max-w-5xl items-center gap-10 px-4 md:grid-cols-[0.6fr_1fr]">
        <BookMockup width="max-w-[220px]" />
        <div>
          <h2 className="text-3xl font-extrabold">Dein Neustart in der Schweiz beginnt mit der richtigen Vorbereitung.</h2>
          <p className="mt-4 text-blue-100">
            Spare Zeit, Nerven und Geld: Mit klaren Schritten, Checklisten und Praxiswissen startest du sicher in dein neues Leben.
          </p>
          <CtaButton large className="mt-7">Jetzt auf Amazon sichern</CtaButton>
        </div>
      </div>
    </section>
  );
}

export default FinalCta;